/**
 * Directive for the Edit Portal Page Available Sign Ups section.
 * Do not change the directive name here as its used dynamically in the view to load multiple instances
 */
SUGApp.directive("sugSignups", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionSignups.html",
        scope: {
            data: '=',
            section: '=',
            onEvent: '&?'
        },
        controller:
                ['$scope','$filter','$q','$timeout','SUGUtilities','sugCacheFactory','errorService','settingService','globalService','portalService',
        function($scope , $filter , $q , $timeout , SUGUtilities , sugCacheFactory , errorService , settingService , globalService , portalService)
        {
            // $scope refers to scope of this perticular directive instance.
            //init error service
            $scope.es = errorService.newInstance();
            $scope.es.init();

            /* Init vars */
            $scope.loaded = false;
            $scope.sectioncontent = {};     //parsed JSON string
            $scope.selectedSignups = [];
            $scope.selectedSignupsFiltered = [];
            $scope.showEmbedPPWarning = false;

            /* Form Elements */
            $scope.frmObj = {
                  searchFilter: ''
                , orderColumn:  ''
                , direction:    ''
                , numPerPage:   0
            };

            $scope.recordCount = 0;
            $scope.dateFormat = 'mm/dd/yyyy';

            /* Text Strings */
            $scope.strings = {
                  asc:              'ASC'
                , desc:             'DESC'
                , signups:          'Available Sign Ups'
                , noData:           'Edit this section to add sign ups or folders.'
                , noDataPublic:     'There are no available sign ups.'
                , noDataFilterOn:   'No data matched your filter criteria. Please try again.'
                , noDataInFolder:   'There are no available sign ups in this folder.'
                , itemsPerPageInvalid: 'Items per page must be a number greater than 0.'
                , tips:   {
                      iconview:     'Show Thumbnail View'
                    , listview:     'Show List View'
                }
                , headerThumb:    'Thumbnail'
                , headerDetails:  'Sign Up Details'
                , headerDates:    'Sign Up Dates'
            };

            $scope.embedwarning = {
                type:         'warning'
              , title:        ''
              , text:         '<strong>Embedding is not compatible with sign ups that accept PayPal payments.</strong><br>Please consider <a href="/index.cfm?go=o.PGActivation" target="_blank" class="sug-link">converting to WePay</a> to ensure your payment sign up remains embedded. Your portal can still be embedded if you continue to use PayPal, but all payment sign ups and tab groups that contain a payment sign up will open in a new SignUpGenius.com browser tab when clicked.'
              , dismissable:  false
              , show:         true
              , noshadow:     true
            };

            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingSignups', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };

            /* Tooltip vars */
            $scope.popTrig = 'mouseenter';
            $scope.popPlacement = 'top';
            $scope.popDelay = 300;

            /*
             * Crucial to keep this in an object to ensure protoypical inheritence. If we pass this as a primitive array,
             * we will lose the binding in the sug-advanced-breadcrumb directive.
             * Great explaination on angularjs scoping: https://stackoverflow.com/questions/15719558/isolated-scope-with-simple-angularjs-nested-directive
             */
            $scope.crumbObj = {
                crumbtrail: []
            };

            /************************
             SORTING and PAGINATION
            ************************/
            /**
             * Appends the crumb to the breadcrumb trail
             * @param {Object} crumb - crumb to element to add to the breadcrumb trail {title:''}
             */
            $scope.appendCrumb = function(crumb){
                $scope.crumbObj.crumbtrail.push(crumb);
                $scope.filterSelectedSignups();
            };

            /* Pagination */
            $scope.pagination = {
                currentPage: 1,
                maxSize: 5,
                numPerPage: 5
            };

            /* Sort Options for Settings Popover */
            $scope.sortOptions = [
                { label: $scope.strings.asc , value: false },
                { label: $scope.strings.desc , value: true }
            ];

            /* Column Direct Sort */
            $scope.setSort = function (columnKey) {
                $scope.frmObj.orderColumn = columnKey;
                $scope.frmObj.direction = !$scope.frmObj.direction;
                $scope.glyphDir = $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
                $scope.filterSelectedSignups();
            };

            /**
             * Determines if a signup element is in the current breadcrumb folder.
             * @param {Object} signup - a single signup object from the selected signups array
             */
            var filterByFolder = function(signup){
                var blnInFilter = false;

                //Root Folder
                if ($scope.crumbObj.crumbtrail.length === 1 && signup.foldername.length === 1 && signup.foldername[0] === '') {
                    blnInFilter = true;
                } else {
                    //Sub Folder: second check ensures this is the actual SubFolder in play
                    blnInFilter = ($scope.crumbObj.crumbtrail[$scope.crumbObj.crumbtrail.length - 1].title === signup.foldername[signup.foldername.length - 1])
                               && ($scope.crumbObj.crumbtrail.length === signup.foldername.length);
                }

                return blnInFilter;
            };

            /* Apply Settings/Filter */
            $scope.filterSelectedSignups = function() {

                //do not process if we this variable is not yet loaded
                if ($scope.selectedSignups.length === 0) {
                    return;
                }

                // Prioritize sorting column(s) always breaking tie with 'title' column
                var orderBy = [$scope.frmObj.orderColumn];
                var sortPriority = { f: 0, t: 1, s: 2 };

                if ($scope.frmObj.orderColumn === 'startdate') {
                    orderBy = ['startdate','title'];
                } else if ($scope.frmObj.orderColumn === 'enddate') {
                    orderBy = ['enddate','title'];
                } else if ($scope.frmObj.orderColumn === 'type') {
                    orderBy = ['sortpriority','title'];
                } else if ($scope.frmObj.orderColumn === 'group') {
                    orderBy = ['sortpriority','group','title'];
                }

                // first apply the breadcrumb filter, if applicable
                var arrayToFilter = ( $scope.crumbObj.crumbtrail.length ) ? $filter('filter')($scope.selectedSignups, filterByFolder) : $scope.selectedSignups;
                // Apply images and dates to our virtual folders
                arrayToFilter = parseFolderImages($scope.selectedSignups,arrayToFilter);

                // add Sort Priority by type
                for (var i in arrayToFilter) {
                    if (arrayToFilter.hasOwnProperty(i)) {
                        arrayToFilter[i].sortpriority = sortPriority[arrayToFilter[i].type];
                    }
                }
                //Apply search filter if found
                if ($scope.frmObj.searchFilter !== '') {
                    arrayToFilter = $filter('filter')(arrayToFilter, $scope.searchFilteredSelectedSignups ); //filter specific data points of the main data array with the search value
                }

                $scope.selectedSignupsFiltered = $filter('orderBy')(arrayToFilter, orderBy, $scope.frmObj.direction); //sort the result

                $scope.recordCount = $scope.selectedSignupsFiltered.length;

                // Apply Pagination
                if ($scope.selectedSignupsFiltered.length && $scope.pagination.currentPage !== 1) {
                    var begin = ($scope.pagination.currentPage - 1) * parseInt($scope.pagination.numPerPage);
                    var end = begin + parseInt($scope.pagination.numPerPage);
                    $scope.selectedSignupsFiltered = $scope.selectedSignupsFiltered.slice(begin, end);

                    // If end up with no results, recursively step back until we get valid paged results
                    if (!$scope.selectedSignupsFiltered.length && $scope.pagination.currentPage > 1) {
                        $scope.pagination.currentPage--;
                        $scope.filterSelectedSignups();
                    }
                }
            };

            /**
             * Searches for a folder image to display
             * Applies dates and images to folders
             * Params : selected, filter (ArrayToFilter)
             * Returns: filter (ArrayToFilter)
             **/
            var parseFolderImages = function (selected,filter) {
                if (selected.length === 0) {
                    return;
                }

                 var level = $scope.crumbObj.crumbtrail.length;

                // Find top level folders and get an appropriate image
                for (var f = 0, len = filter.length; f < len; f++) {
                    //Only process if type is folder
                    if (filter[f].type == 'f') {
                        filter[f].folderitems = 0;
                        //These are placeholders so startdate and enddate are always picked
                        filter[f].startdate = 9999999999999;
                        filter[f].enddate = 0;

                        for (var s = 0, slen = selected.length; s < slen; s++) {
                            var signupTabgroup = (selected[s].type == "s" || selected[s].type == "t");
                            //Updated routine so it counts folders as well
                            if (signupTabgroup || selected[s].type == "f" ) {
                                var folder = selected[s].foldername[level];
                                var imagepath = selected[s].imagepath;

                                //Set start stop dates on folders
                                if (signupTabgroup) {
                                    if ( selected[s].enddate > filter[f].enddate ) {
                                        filter[f].enddate = angular.copy(selected[s].enddate);
                                    }

                                    if ( selected[s].startdate < filter[f].startdate ) {
                                        filter[f].startdate = angular.copy(selected[s].startdate);
                                    }
                                }

                                if (typeof folder !== 'undefined') {
                                    //Checks to make sure we are on the same level otherwise the path is different
                                    if (folder == filter[f].title && level === selected[s].foldername.length - 1) {
                                        //process folder count
                                        filter[f].folderitems++;
                                        //process folder cover image if there is one available
                                        if (typeof filter[f].imagepath === 'undefined' && typeof imagepath !== 'undefined') {
                                            filter[f].imagepath = imagepath;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                return filter;
            };


            /* Prepare Settings/Filter */
            var prepareSettings = function () {
                $scope.settingID = 'settingID' in $scope.frmObj ? $scope.frmObj.settingID : 0;
                if (!('searchFilter' in $scope.frmObj)) {
                    $scope.frmObj.searchFilter = '';
                }
                if (!('orderColumn' in $scope.frmObj)) {
                    $scope.frmObj.orderColumn = 'title';
                }
                if (!('direction' in $scope.frmObj)) {
                    $scope.frmObj.direction = false;
                }
                if (!('numPerPage' in $scope.frmObj)) {
                    $scope.frmObj.numPerPage = 8;
                }
                $scope.glyphDir =  $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
                $scope.pagination.numPerPage = $scope.frmObj.numPerPage;
            };

            /************************
             SEARCH FILTERS
            ************************/
            $scope.searchFilteredSelectedSignups = function(objSelectedSignup){
                //Only certain types (signup, folder, tab group) have certain data points to search on below
                if( !$scope.frmObj.searchFilter
                    //|| objSelectedSignup.id == $scope.frmObj.searchFilter  -- Betsy requested we not search by ID
                    || objSelectedSignup.title.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                    || (objSelectedSignup.type !== 'f' && objSelectedSignup.urlid.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    || (objSelectedSignup.type === 's' && objSelectedSignup.group.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    || (objSelectedSignup.type !== 'f' && objSelectedSignup.startdatesearchable.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    || (objSelectedSignup.type !== 'f' && objSelectedSignup.enddatesearchable.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    ){
                    return true;
                } else {
                    return false;
                }
            };

            // Determines if the search filter input should be displayed
            $scope.showSearchFilter = function(){
                return $scope.recordCount > $scope.frmObj.numPerPage || $scope.frmObj.searchFilter.length > 0;
            };

            /************************
             MANAGE DATA
            ************************/

            /**
             * Listen for the save event from the slide out so you can update the instance view
             */
            $scope.$on('portal_savesignups', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update view
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && typeof val.signupsData !== 'undefined'
                    && typeof val.selectedSignups !== 'undefined'
                    && val.sectionId == $scope.section.id)
                {
                    // Update data models to trigger view changes
                    $scope.sectioncontent = angular.copy( val.signupsData );
                    $scope.selectedSignups = val.selectedSignups;

                    // Handle epoch dates without times (set to midnight)
                    addFormattedDates();

                    var signuptitle = $scope.strings.signups;

                    if ($scope.sectioncontent.title.length > 0) {
                        signuptitle = $scope.sectioncontent.title;
                    }

                    $scope.crumbObj.crumbtrail = [{title: signuptitle}];

                    //data is loaded in the main controller, so clone it into some vars and fire off some functions here
                    $scope.selectedSignupsFiltered = angular.copy( $scope.selectedSignups );
                    $scope.recordCount = $scope.selectedSignupsFiltered.length;

                    // Update Settings with SectionContent data
                    $scope.frmObj.orderColumn = ( typeof $scope.sectioncontent.sortby !== 'undefined' ) ? $scope.sectioncontent.sortby : 'title';
                    $scope.frmObj.direction = ( typeof $scope.sectioncontent.sortdir !== 'undefined' ) ? ( $scope.sectioncontent.sortdir == 'asc') ? false : true : false;
                    $scope.frmObj.numPerPage = ( typeof $scope.sectioncontent.perpage !== 'undefined' ) ? $scope.sectioncontent.perpage : 8;

                    $scope.toggleView( $scope.sectioncontent.display );


                    $scope.filterSelectedSignups();

                    SUGUtilities.broadCast('isProcessing', false);
                    $scope.loaded = true;

                }
            });

            /**
             * Unwrap the event handler function(s) so that we can pass in parameters inside the directive markup
             */
            function unwrapHandlers(){
                if( typeof $scope.onEvent === 'function' ){
                    $scope.onEvent = $scope.onEvent();
                }
            }

            /**
             * Initilize the view
             */
            var init = function() {
                // map passed in function references
                unwrapHandlers();

                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingSignups', { 'sectionId': $scope.section.id, 'isprocessing': true });

                parseData();
            };


            /**
             * Method loads the info for the section directive from main data model
             */
            var parseData = function(){
                $scope.sectioncontent = JSON.parse( $scope.section.sectioncontent );
                //get the creator's selected dateAndTZFormats from the portal data
                if( typeof $scope.data.portalInfo.portal.dateformats != 'undefined'){
                    var arrDF = $scope.data.portalInfo.portal.dateformats;
                    for (var i = 0, len = arrDF.length; i < len; i++) {
                        var val = arrDF[i];
                        if (val.selected) {
                            $scope.dateFormat = val.short.replace('mm', 'MM');
                            $scope.strings.dateFormat = val.short;
                            break;
                        }
                    }
                }

                // clear the grid filter
                $scope.frmObj.searchFilter = '';

                loadData();
            };

            /**
             * Method loads the data from the service if parseData() yields no values
             */
            var loadData = function(){
                $scope.frmObj = sugCacheFactory.get('frmObjSignupsPreview',{});

                prepareSettings();

                //load selected sign ups
                portalService.getSignupSectionData({
                              owner: $scope.data.portalInfo.portal.memberid
                            , portalID: $scope.section.portalid
                            , portalSectionID: $scope.section.id
                    }).then(function( response ){
                    //validate the response
                    if( SUGUtilities.ajaxResultInvalid( response.data ) ){
                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingSignups', { 'sectionId': $scope.section.id, 'isprocessing': false });

                        $scope.es.setError('signupssection', SUGUtilities.getAjaxResponseMessage(response) );
                    } else {
                        //response was valid
                        var r = SUGUtilities.lowerCaseKeys( response.data );
                        if( r.success && r.data.length ){
                            $scope.selectedSignups = r.data;
                        } else {
                            $scope.selectedSignups = [];
                        }

                        // Handle epoch dates without times (set to midnight)
                        addFormattedDates();

                        //Determine if we show the emebd warning message
                        checkForEmbedPPWarning();

                        // if we dont have all sign ups enabled, initialize the crumbtrail to "Sign Ups"
                        // Can't use SUGUtilities.isIntegerGT0 here bc this value is true/false for radio button use

                        var signuptitle = $scope.strings.signups;

                        if ($scope.sectioncontent.title.length > 0) {
                            signuptitle = $scope.sectioncontent.title;
                        }

                        $scope.crumbObj.crumbtrail = [{title: signuptitle}];

                        //data is loaded in the main controller, so clone it into some vars and fire off some functions here
                        $scope.selectedSignupsFiltered = angular.copy( $scope.selectedSignups );
                        $scope.recordCount = $scope.selectedSignupsFiltered.length;

                        // Update Settings with SectionContent data, since we don't save settings
                        $scope.frmObj.orderColumn = ( typeof $scope.sectioncontent.sortby !== 'undefined') ? $scope.sectioncontent.sortby : 'title';
                        $scope.frmObj.direction = ( typeof $scope.sectioncontent.sortdir !== 'undefined') ? ( $scope.sectioncontent.sortdir == 'asc') ? false : true : false;
                        $scope.frmObj.numPerPage = ( typeof $scope.sectioncontent.perpage !== 'undefined') ? $scope.sectioncontent.perpage : 8;

                        $scope.filterSelectedSignups();

                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingSignups', { 'sectionId': $scope.section.id, 'isprocessing': false });
                        $scope.loaded = true;
                    }
                });
            };

            /**
             * Method updates the objects in the selectedSignups array with a new key that has a Local Date that can be used for formatting
             * If the regular epoch date is formatted, if its time is midnight, the date will appear one day behind
             * This function needs to run anytime the selectedSignups array is updated.
             */
            var addFormattedDates = function(){
                $scope.selectedSignups.forEach( function(item){
                    item.startdateparsed = SUGUtilities.utcToLocalDate( new Date( item.startdate ) );
                    item.enddateparsed = SUGUtilities.utcToLocalDate( new Date( item.enddate ) );

                    item.startdatesearchable = $filter('date')(item.startdateparsed, $scope.dateFormat);
                    item.enddatesearchable = $filter('date')(item.enddateparsed, $scope.dateFormat);
                });
            };

            /**
             * When editing a Portal Pg, this method checks each sign up in the selectedSignups array to determine if it has PayPal payments.
             * If even 1 sign up has PP items, broadcast an event to trigger the warning message to show, then escape the loop.
             * Warning message will appear in the embed instructions slide out in the edit view
             */
            var checkForEmbedPPWarning = function(){
                if( $scope.data.portalInfo.portal.mode == 'private' ){
                    for (var i=0, len=$scope.selectedSignups.length; i < len; i++) {
                        var su = $scope.selectedSignups[i];
                        if( typeof su.ispp !== 'undefined' && su.ispp  ){
                            $scope.onEvent('portal_ppwarning', { 'showwarning': true });
                            break;
                        }
                    }
                }
            };

            $scope.toggleView = function( display ){
                $scope.sectioncontent.display = ( typeof display !== 'undefined' && (display == 'list' || display == 'thumb') ) ? display : 'thumb';
            };

            /**
             * Method scrolls to the top of the section when the pagination control is clicked
             * Originaly this was in the $watcher,m however that caused it to fire on page load
             * Now it is standalone and triggered by the pagination control's onClick event
             * @sectionid - Required - Valid id of the unique section triggering the click
             */
            $scope.setScroll = function (sectionid ){
                if( typeof sectionid != 'undefined' && sectionid == $scope.section.id ){
                    //scroll to the top of the section when paginated
                    var sectionContainer = document.getElementById("su" + $scope.section.id);
                    if( typeof sectionContainer !== 'undefined' && sectionContainer != null){
                        sectionContainer.scrollIntoView();
                    }
                }
            };

            /**
             * Helper method to generate a link to a sign up page
             *
             * @eleType - String, Required - single letter indicating the type of item (s-signup, t-tabs, f-folder)
             * @urlid - String, Required - Valid urlid of the sign up the link is for
             */
            $scope.getSignupLink = function ( eleType, urlid ){
                var link = '', gosrc = '';

                if( typeof urlid !== 'undefined'
                    && typeof eleType !== 'undefined'
                    && eleType.toString().length
                    && urlid.toString().length ){

                    gosrc = eleType == 't' ? '/tabs/' : '/go/';
                    link = $scope.data.fullsecureurl + gosrc + urlid.toString().trim();

                    if($scope.data.portalInfo.portal.mode == 'public' && $scope.data.portalInfo.portal.embeddedmode){
                        link += '/pid/' + $scope.data.portalInfo.portal.id;
                    }

                }
                return link;
            };

            /************************
             SETTINGS GEAR
            ************************/
            $scope.strings.settings = {
                  title:             'Title'
                , type:              'Type'
                , settingsName:      'portals_section_signup'
                , settingsPopover:   'Settings'
                , sortBy:            'Sort By'
                , sortOrder:         'Sort Order'
                , group:             'Group Name'
                , startdate:         'Earliest Start Date'
                , enddate:           'Latest End Date'
            };

            /* Dropdown Click Handler */
            $scope.dropDownClickEvent = function (e) {
                ( typeof e.target.title !== 'undefined' && e.target.title === $scope.strings.settings.saveSettings) ? saveMySettings() : e.stopPropagation() ;
            };

            /* Save Settings */
            var saveMySettings = function () {
                sugCacheFactory.set('frmObjSignupsPreview', angular.copy($scope.frmObj) );
            };

            /************************
             END SETTINGS GEAR
            ************************/



            /************************
             WATCHERS
            ************************/

            /* Watch Pagination  - DO NOT PREFIX THESE VARS WITH $scope. (ex. $scope.pagination) */
            $scope.$watch('pagination.currentPage + pagination.numPerPage', function () {
                $scope.filterSelectedSignups();
            });

            /* Watch Form Object */
            $scope.$watchCollection('frmObj', function (nVal, oVal) {
                var newVal = angular.copy(nVal);
                var oldVal = angular.copy(oVal);

                if (newVal !== oldVal) {
                    // validate number per page (stop processing if empty or invalid since we must have it for proper filter/sort)
                    if (!$scope.frmObj.numPerPage || $scope.frmObj.numPerPage.toString().trim() === '') {
                        return;
                    } else if (!(angular.isNumber(~~$scope.frmObj.numPerPage) && isFinite(~~$scope.frmObj.numPerPage)) || ~~$scope.frmObj.numPerPage <= 0) {
                        SUGUtilities.showMagnificAlert($scope.strings.itemsPerPageInvalid, 'error', 'Cannot sort data', 'Sorry!');
                        $scope.frmObj.numPerPage = oldVal.numPerPage;
                        return;
                    }

                    // Prioritize sorting column(s) always breaking tie with 'title' column
                    var orderBy = [$scope.frmObj.orderColumn];
                    if(orderBy[0] !== 'title'){
                        if($scope.frmObj.direction){ orderBy.push('-title'); } else { orderBy.push('title'); }
                    }

                    /* Apply Filter - Filter through the data Array, NOT the filtered data */
                    $scope.selectedSignupsFiltered = $filter('orderBy')($scope.selectedSignups, orderBy, $scope.frmObj.direction);

                    prepareSettings();

                    //previous code was grabbing phantom objects and
                    //would also duplicate items when removing the search filter
                    $scope.filterSelectedSignups();
                }
            });


            init();
        }] // end controller

    }); // END return
});
